// extracted by mini-css-extract-plugin
export default {"layout":"B4c15q_W","content":"IlTDh1bB","breadcrumbLink":"WFSLKSgh"};